// §32 / §9.1 — Timber as an in-process app.
//
// Manifest only (D-247): the engine, the generator, the projection, the view and the CSS all live
// behind the thunk, so a desktop that never opens this window downloads none of it (D-199, D-367).
//
// Not a factory. Timber is single-player and reads no §14 number and no clock — its towers are
// seeded from the run, not from the date (D-433) — so it takes no capability, and taking one would
// imply a daily board it does not have.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createTimberApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'timber',
      name: 'Timber',
      // §32.1 — `package` was already in the closed glyph union and unclaimed: a box drawn as a
      // cube with its lid seam showing, which is the game in one icon.
      icon: { glyph: 'package', hue: 30 },
      keywords: ['blocks', 'wood', 'tap', 'away', '3d', 'tower', 'puzzle', 'game', 'arcade'],
      category: 'Arcade',
      // §32.1 (D-434) — the Arcade's fifth sub-group header, and the one Timber opens.
      group: 'Puzzle',
      requiresAuth: true,
      // Free-resizing DOM, not a letterboxed canvas (D-374): the camera fits the tower to whatever
      // box it is given, so a wider window is more room to look rather than a stretched picture.
      window: { width: 780, height: 720, minWidth: 460, minHeight: 480, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        { id: 'restart-tower', label: 'Restart tower' },
      ],
    },
    load: () => import('./Timber'),
  });
}
